import PropTypes from 'prop-types'
import { Component } from 'react'
import { connect } from 'react-redux'
import { getFiltros } from '../../actions/filtros'
import { getTiras } from '../../actions/tiras'
import Banners from './Banners'

export class Home extends Component {
  static propTypes = {
    getFiltros: PropTypes.func.isRequired,
    getTiras: PropTypes.func.isRequired,
  }

  componentDidMount() {
    this.props.getFiltros()
    this.props.getTiras()
  }

  componentDidUpdate() {
    window.wookie()
  }

  render() {
    return (
      <div className='home-hero'>
        <Banners id_banner='BHOME' />
      </div>
    )
  }
}

const mapStateToProps = state => ({})

export default connect(mapStateToProps, {
  getFiltros,
  getTiras,
})(Home)
